// extracted by mini-css-extract-plugin
export default {"header":"Dashboard_header__HjXpL","container":"Dashboard_container__5JT1Q"};